"use strict";

var __extends = this && this.__extends || function () {
  var extendStatics = Object.setPrototypeOf || {
    __proto__: []
  } instanceof Array && function (d, b) {
    d.__proto__ = b;
  } || function (d, b) {
    for (var p in b) {
      if (b.hasOwnProperty(p)) d[p] = b[p];
    }
  };

  return function (d, b) {
    extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
      r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
      d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
    if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  }
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
  }
  result["default"] = mod;
  return result;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var React = __importStar(require("react"));

var mui_extension_1 = require("mui-extension");

var core_1 = require("@material-ui/core");

var Datatable_1 = require("../Datatable");

var react_redux_1 = require("react-redux");

var DatatableColumnsFilter_1 = __importDefault(require("./DatatableColumnsFilter"));

var autobind_decorator_1 = __importDefault(require("autobind-decorator"));

var lodash_debounce_1 = __importDefault(require("lodash.debounce"));

var styles = function styles(t) {
  return core_1.createStyles({
    row: {
      background: t.palette.background.default,
      minHeight: 56,
      position: 'relative',
      paddingLeft: t.spacing.unit * 1.5,
      paddingRight: t.spacing.unit * 1.5,
      display: 'flex',
      alignItems: 'center',
      borderBottom: "1px solid " + t.palette.divider
    },
    content: {
      flex: 1
    },
    actions: {
      paddingLeft: t.spacing.unit
    },
    search: {
      position: 'absolute',
      top: 0,
      right: 0,
      left: 0,
      bottom: -1,
      background: t.palette.background.paper,
      borderBottom: "2px solid " + t.palette.primary.main,
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      paddingLeft: t.spacing.unit * 1.5,
      paddingRight: t.spacing.unit * 1.5
    },
    search_input: {
      flex: 1,
      border: 'none',
      background: 'none',
      marginLeft: t.spacing.unit,
      fontSize: t.typography.subheading.fontSize,
      height: '100%',
      outline: 'none'
    }
  });
};

var DatatableToolbar =
/** @class */
function (_super) {
  __extends(DatatableToolbar, _super);

  function DatatableToolbar() {
    var _this = _super !== null && _super.apply(this, arguments) || this;

    _this.state = {
      showSearch: false
    };
    _this.handleSearch = lodash_debounce_1.default(function (value) {
      var _a = _this.props,
          actions = _a.actions,
          search = _a.search,
          dispatch = _a.dispatch;

      if (search) {
        dispatch(actions.updateCriteria(search, value));
      }
    }, 400);
    return _this;
  }

  DatatableToolbar.prototype.render = function () {
    var _this = this;

    var _a = this.props,
        classes = _a.classes,
        children = _a.children;
    return React.createElement("div", {
      className: classes.row
    }, React.createElement(mui_extension_1.IconBtn, {
      onClick: this.toggleSearchInput
    }, React.createElement(core_1.Icon, null, "search")), React.createElement("div", {
      className: classes.content
    }, children), React.createElement("div", {
      className: classes.actions
    }, React.createElement(DatatableColumnsFilter_1.default, null)), this.state.showSearch && React.createElement("div", {
      className: classes.search
    }, React.createElement(mui_extension_1.IconBtn, {
      onClick: this.toggleSearchInput
    }, React.createElement(core_1.Icon, null, "search")), React.createElement("input", {
      autoFocus: true,
      className: classes.search_input,
      placeholder: "Search",
      onChange: function onChange(_a) {
        var value = _a.target.value;
        return _this.handleSearch(value);
      }
    }), React.createElement(mui_extension_1.IconBtn, {
      onClick: this.handleClearSearch
    }, React.createElement(core_1.Icon, null, "clear"))));
  };

  DatatableToolbar.prototype.toggleSearchInput = function () {
    this.setState(function (state) {
      return {
        showSearch: !state.showSearch
      };
    });
  };

  DatatableToolbar.prototype.handleClearSearch = function (event) {
    var _a = this.props,
        actions = _a.actions,
        search = _a.search,
        dispatch = _a.dispatch;
    if (search) dispatch(actions.updateCriteria(search, undefined));
    this.toggleSearchInput();
  };

  __decorate([autobind_decorator_1.default], DatatableToolbar.prototype, "toggleSearchInput", null);

  __decorate([autobind_decorator_1.default], DatatableToolbar.prototype, "handleClearSearch", null);

  return DatatableToolbar;
}(React.Component);

var state2props = function state2props(state, ownProps) {
  var paginateState = state.paginate[ownProps.name];
  return {
    criteria: paginateState.criteria
  };
};

exports.default = Datatable_1.datatableConsumer(core_1.withStyles(styles)(react_redux_1.connect(state2props)(DatatableToolbar)));